import { Suspense, PropsWithChildren, FC } from "react";

import { Column, Spinner } from "@hightouch/htui";

export const PageSuspense: FC<PropsWithChildren> = ({ children }) => {
  return (
    <Suspense
      fallback={
        <Column height="100%" width="100%" align="center" justify="center">
          <Spinner size="lg" m="auto" />
        </Column>
      }
    >
      {children}
    </Suspense>
  );
};
